export default __webpack_public_path__ + "static/media/tn-ventas-03.7b8fdf44.jpg";